import angular from 'angular';

import config from '../config';

import profileUrl from './profile.html';

export default function OnboardingCtrl(
  Authentication,
  PersonaCollection,
  RestUtils,
  Utils,
  Upload,
  UserUtils,
  $q,
  $location
) {
  'ngInject';

  const controller = this;
  controller.profileUrl = profileUrl;
  controller.loading = true;
  controller.dateFormat = Authentication.user.settings.usTimeFormat ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

  controller.uploader = angular.copy(Upload.uploader);
  controller.uploader.onSuccessItem = function uploaderOnSuccessItem(fileItem, { url }) {
    if (url && url.indexOf('http') === 0) {
      controller.user.avatar = url;
      controller.profileForm.$setDirty();
    }
  };

  controller.user = PersonaCollection.me;
  if (controller.user.pending) {
    controller.user.oldEmail = angular.copy(controller.user.email);
    controller.user.email = angular.copy(controller.user.pending);
  }

  controller.user.emailCopy = angular.copy(controller.user.email);

  async function _load() {
    controller.user.session = await UserUtils.getSession();
    controller.user.toastIdentityGuid = controller.user.session?.toastIdentityGuid;

    if (!controller.user.countryCode) {
      RestUtils.getGeo().then((geo) => {
        controller.geo = geo;
        controller.loading = false;
      });
    } else {
      controller.loading = false;
    }
  }

  function _save() {
    if (controller.profileForm?.$dirty) {
      return controller.user.put({ 'user-fields': 'full' });
    }

    return $q.resolve();
  }

  _load();

  controller.completeOnboarding = async function completeOnboarding() {
    if (controller.uploader.queue.length || controller.profileForm.$invalid) {
      return $q.reject();
    }

    await _save();
    Authentication.user.settings.onboardingComplete = true;
    Authentication.user.settings.clientFlags._userCreatedAfterRecurrenceRelease = true;
    Authentication.syncSettings();
    $location.path(config.AFTER_ONBOARDING_PATH);

    if (!__TEST__) {
      return $q(() => {}); // make the progress-button load until redirection
    }
  };

  controller.selectCountryCode = function selectCountryCode({ value, code }) {
    controller.user.countryCode = value;
    controller.user.countryISOCode = code;
  };
}
